<template>
  <transition :name="transitionEffect">
    <div
      class="event-name-item"
      v-show="currentEvent === index"
      @mouseenter="$emit('mouseenter')"
      @mouseout="$emit('mouseout')"
    >
      <p>{{ event }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  emits: ['mouseenter', 'mouseout'],
  props: ['event', 'currentEvent', 'index', 'direction'],
  computed: {
    transitionEffect () {
      return this.direction === 'right' ? 'slide-out' : 'slide-in'
    }
  }
}
</script>

<style scoped>
.event-name-item {
  margin: 5px;
}
.slide-in-enter-active,
.slide-in-leave-active,
.slide-out-enter-active,
.slide-out-leave-active {
  transition: all 1s ease-in-out;
}
.slide-in-enter-from {
  transform: translateX(-100%);
}
.slide-in-leave-to {
  transform: translateX(100%);
}
.slide-out-enter-from {
  transform: translateX(100%);
}
.slide-out-leave-to {
  transform: translateX(-100%);
}
</style>
